module.exports = __webpack_public_path__ + "img/strategic.29218b83.png";